import { auth } from './auth'
import { responses } from './responses'
import { responseTags } from './response-tags'
import { emailTemplate } from './email-template'
import { emailServer } from './email-server'
import { cms } from './cms'
import { form } from './form'
import { category } from './category'
import { field } from './field'
import { workspaceApi } from './workspace'
import { payment } from './payment'
import { webhook } from './webhook'
import { share } from './share-access'
import { userForms } from './user-forms'

export const services = {
  auth,
  responses,
  responseTags,
  emailTemplate,
  emailServer,
  cms,
  form,
  category,
  field,
  workspaceApi,
  payment,
  webhook,
  share,
  userForms,
}
